import { useContext } from 'react';
import { NotificationsContext } from './NotificationsContext';

function useNotification() {
  const {
    notification,
    addNotification,
    removeNotification,
    isNotificationVisible,
    setIsNotificationVisible
  } = useContext(NotificationsContext);

  return {
    notification,
    addNotification,
    removeNotification,
    isNotificationVisible,
    setIsNotificationVisible
  };
}

export default useNotification;